import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

export function getIsGwp10027NonprofitPricingPage() {
	return checkFeatureFlagGate(featureFlags.gwp10027NonprofitPricingPage);
}
